import React from 'react';
import '../../../../../assets/css/Modal.css'

import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import YearController from "../../../../../services/data-declaration/year-controller";

class modalDeleteSchoolYear extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reason: '',
            showBlock: true,
            signupInfo: null
        };
    }

    delete = () => {
        let payload = {
            id: this.props.id,
        }
        YearController.delete(payload, res => {
            if (res.success) {
                toast.success("Xóa năm học thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.warning(res.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000
                });
            }
        })
    }


    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>

                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>THÔNG BÁO</b></h1>
                        </div>

                        <div className='d-flex justify-content-center mt-3 mb-3'>
                            <label className='font-size-content'>Bạn có muốn xóa thời gian năm học này không?</label>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.delete()}
                                >
                                        <span className='justify-content-center'>
                                            Đồng ý
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export  default  modalDeleteSchoolYear
